import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {ContentSurface, Prose} from "../components/ContentPage";
import CookiePolicy from "../legal/CookiePolicy";

/**
 * Public, pre-rendered Cookie Policy page (ui#97). Renders the SAME {@link CookiePolicy} content the
 * "Resources" menu's dialog shows — one source, two surfaces — as in-flow SSG markup. The component
 * already links to {@link /privacy}, so the legal pages cross-link for crawlers.
 */
export function Component() {
	const {resourceTitles, seo} = useMessages();
	return (
		<>
			<Seo
				title={seo.cookies.title}
				description={seo.cookies.description}
				path="/cookies"
			/>
			<ContentSurface>
				<Prose>
					<h1>{resourceTitles.cookie}</h1>
					<CookiePolicy/>
				</Prose>
			</ContentSurface>
		</>
	);
}
